import Vue from 'vue';
import Router from 'vue-router';
import Layout from "../layout/index";
Vue.use(Router);
export var constantRouterMap = [{
  path: '/login',
  meta: {
    title: '登录',
    noCache: true
  },
  component: function component(resolve) {
    return require(['@/views/login'], resolve);
  },
  hidden: true
}, {
  path: '/404',
  component: function component(resolve) {
    return require(['@/views/features/404'], resolve);
  },
  hidden: true
}, {
  path: '/401',
  component: function component(resolve) {
    return require(['@/views/features/401'], resolve);
  },
  hidden: true
}, {
  path: '/retrieve',
  component: function component(resolve) {
    return require(['@/views/retrieve'], resolve);
  },
  hidden: true
}, {
  path: '/resetPass',
  component: function component(resolve) {
    return require(['@/views/resetPass'], resolve);
  },
  hidden: true
}, {
  path: '/transfer',
  component: function component(resolve) {
    return require(['@/views/transfer'], resolve);
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    component: function component(resolve) {
      return require(['@/views/home'], resolve);
    },
    name: 'Dashboard',
    meta: {
      title: '首页',
      icon: 'index',
      affix: true,
      noCache: true
    }
  }]
}, {
  path: '/user',
  component: Layout,
  hidden: true,
  redirect: 'noredirect',
  children: [{
    path: 'center',
    component: function component(resolve) {
      return require(['@/views/system/user/center'], resolve);
    },
    name: '个人中心',
    meta: {
      title: '个人中心'
    }
  }, {
    path: 'useHelp',
    component: function component(resolve) {
      return require(['@/views/system/user/useHelp'], resolve);
    },
    name: '使用帮助',
    meta: {
      title: '使用帮助'
    }
  }]
}];
export default new Router({
  mode: 'hash',
  // mode: "history",
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  // base: process.env.BASE_URL,
  routes: constantRouterMap
});